<template>

    <v-carousel :show-arrows="false" hide-delimiters cycle height="auto">
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <img :src="slide.image">
      </v-carousel-item>
    </v-carousel>

</template>

<script>

  export default {
    data: () => ({

    }),
    methods:{

    },
    computed: {
      slides(){
        return this.$store.getters.loadedSlides;
      }
    },
    created(){
      this.$store.dispatch('loadSlides');
    }
  }

</script>

<style scoped>

</style>